import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { TORUS_LEGACY_NETWORK, TORUS_SAPPHIRE_NETWORK } from '@toruslabs/constants';

const storeKey = "auth_store";
const WEB3AUTH_LEGACY_NETWORK = TORUS_LEGACY_NETWORK;
const WEB3AUTH_SAPPHIRE_NETWORK = TORUS_SAPPHIRE_NETWORK;
const WEB3AUTH_NETWORK = _objectSpread(_objectSpread({}, WEB3AUTH_SAPPHIRE_NETWORK), WEB3AUTH_LEGACY_NETWORK);
const SUPPORTED_KEY_CURVES = {
  SECP256K1: "secp256k1",
  ED25519: "ed25519",
  OTHER: "other"
};
const MFA_LEVELS = {
  DEFAULT: "default",
  OPTIONAL: "optional",
  MANDATORY: "mandatory",
  NONE: "none"
};
const AUTH_ACTIONS = {
  LOGIN: "login",
  ENABLE_MFA: "enable_mfa",
  MANAGE_MFA: "manage_mfa",
  ADD_SOCIAL_FACTOR: "add_social_factor",
  MODIFY_SOCIAL_FACTOR: "modify_social_factor",
  ADD_AUTHENTICATOR_FACTOR: "add_authenticator_factor",
  ADD_PASSKEY_FACTOR: "add_passkey_factor"
};
const BUILD_ENV = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
  STAGING: "staging",
  TESTING: "testing"
};
const SDK_MODE = {
  DEFAULT: "default",
  IFRAME: "iframe"
};
const JRPC_METHODS = {
  SETUP_COMPLETE: "setup_complete",
  INIT_DAPP: "init_dapp",
  LOGIN_INITIATED: "login_initiated",
  LOGIN_CANCELLED: "login_cancelled",
  LOGIN_FAILED: "login_failed",
  LOGIN_SUCCESS: "login_success",
  DISPLAY_IFRAME: "display_iframe",
  HIDE_IFRAME: "hide_iframe"
};
const IFRAME_MODAL_ID = "auth-iframe";
const DEFAULT_SESSION_TIME = 30 * 24 * 60 * 60; // 30 days

const CITADEL_SERVER_URL_PRODUCTION = "https://api.web3auth.io/citadel-server";
const CITADEL_SERVER_URL_STAGING = "https://api.web3auth.io/citadel-server";
const CITADEL_SERVER_URL_DEVELOPMENT = "http://localhost:3020";
const CITADEL_SERVER_URL_TESTING = "https://api-develop.web3auth.io/citadel-server";

// Auth service urls
const AUTH_SERVICE_DEVELOPMENT_URL = "http://localhost:3000";
const AUTH_SERVICE_STAGING_URL = "https://staging-auth.web3auth.io";
const AUTH_SERVICE_TESTING_URL = "https://develop-auth.web3auth.io";
const AUTH_SERVICE_PRODUCTION_URL = "https://auth.web3auth.io";

// Auth Dashboard urls
const AUTH_DASHBOARD_DEVELOPMENT_URL = "http://localhost:5173";
const AUTH_DASHBOARD_STAGING_URL = "https://staging-account.web3auth.io";
const AUTH_DASHBOARD_TESTING_URL = "https://develop-account.web3auth.io";
const AUTH_DASHBOARD_PRODUCTION_URL = "https://account.web3auth.io";

// 10 seconds
const POPUP_TIMEOUT = 1000 * 10;

export { AUTH_ACTIONS, AUTH_DASHBOARD_DEVELOPMENT_URL, AUTH_DASHBOARD_PRODUCTION_URL, AUTH_DASHBOARD_STAGING_URL, AUTH_DASHBOARD_TESTING_URL, AUTH_SERVICE_DEVELOPMENT_URL, AUTH_SERVICE_PRODUCTION_URL, AUTH_SERVICE_STAGING_URL, AUTH_SERVICE_TESTING_URL, BUILD_ENV, CITADEL_SERVER_URL_DEVELOPMENT, CITADEL_SERVER_URL_PRODUCTION, CITADEL_SERVER_URL_STAGING, CITADEL_SERVER_URL_TESTING, DEFAULT_SESSION_TIME, IFRAME_MODAL_ID, JRPC_METHODS, MFA_LEVELS, POPUP_TIMEOUT, SDK_MODE, SUPPORTED_KEY_CURVES, WEB3AUTH_LEGACY_NETWORK, WEB3AUTH_NETWORK, WEB3AUTH_SAPPHIRE_NETWORK, storeKey };
